export default [
  {
    title: 'Events',
    route: 'events',
    icon: 'CalendarIcon',
  },
]
